import logoCorreios from "assets/icons/correiosNegative.svg";
import logoCNP from "assets/icons/logo-cnp-cap-branco.svg";
import { getEnvVar } from "utils/environment";
import * as S from "./LinksSection.style";

const LinksSection = () => {
  return (
    <>
      <S.Logos>
        <div data-label="footer cnp link">
          <img src={logoCNP} width={140} height={48} alt="logo cap vencedor" />
          <img src={logoCorreios} height={24} alt="logo cnp" />
        </div>
      </S.Logos>
      <S.Items>
        <S.Item data-label="cnp brasil link">
          <a
            role="button"
            href={getEnvVar("AA_CAPITALIZACAO_SOBRE")}
            target="_blank"
            rel="noreferrer"
            className="make-click"
          >
            Sobre a CNP Capitalização
          </a>
        </S.Item>
        <S.Item data-label="cap carrefour link">
          <a
            role="button"
            href={getEnvVar("AA_CAP_VENCEDOR")}
            target="_blank"
            rel="noreferrer"
            className="make-click"
          >
            Cap Vencedor
          </a>
        </S.Item>
        <S.Item data-label="cookies link">
          <S.LinkStyledButton
            role="button"
            className="make-click"
            onClick={() => window?.cnp?.performance?.consent?.modal?.()}
          >
            Cookies
          </S.LinkStyledButton>
        </S.Item>
        <S.Item data-label="footer privacidade link">
          <a
            role="button"
            href={getEnvVar("AA_CAPITALIZACAO_PORTAL_PRIVACIDADE")}
            target="_blank"
            rel="noreferrer"
            className="make-click"
          >
            Política de Privacidade
          </a>
        </S.Item>
        <S.Item data-label="footer privacidade link">
          <a
            role="button"
            href={"https://www.contatoseguro.com.br/pt/cnpcapitalizacao"}
            target="_blank"
            rel="noreferrer"
            className="make-click"
          >
            Canal de denúncia
          </a>
        </S.Item>
      </S.Items>
    </>
  );
};

export default LinksSection;
